<template>
  <component :is="tag"
    :id="id"
    :class="{'container': !fluid, 'container-fluid': fluid}"
  >
    <slot />
  </component>
</template>

<script>

export default {
  name: 'VContainer',
  props: {
    tag: {
      type: String,
      default: 'div',
    },
    id: String,
    fluid: Boolean,
  },
};
</script>
